export default __webpack_public_path__ + "static/media/tile_resort_excursions.4b18d7a3.jpg";